var angular = require('angular');
var _module = angular.module('benoit');
var _ = require('lodash');
var moment = require('moment');


require('../../filters');

_module.controller('CountdownTimerCtrl', [
    '$scope',
    '$log',
    '$element',
    '$attrs',
    '$interval',

    function CountdownTimerCtrl($scope, $log, $element, $attrs, $interval) {
        $log.debug('CountdownTimerCtrl', this);

        var ct = this;
        ct.model = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            countingDown: true,
            timerInitialized: false
        };

        ct.events = {
        };

        // Lifecycle Hooks
        ct.$onInit = init;
        ct.$onDestroy = destroy;

        function isValidStartEndTime() {
            var t = _.get(ct, 'startEndTime', '');
            $log.debug('Got startEndTime', t);
            return ( t.length && moment(new Date(t)).isValid() );
        }

        function getTimeDiff() {
            var t0 = moment(new Date(ct.startEndTime));
            var t1 = moment();
            return t0.diff(t1);
        }

        function tick() {
            var seconds = getTimeDiff();
            if(_.isFinite(_.toNumber(seconds))) seconds /= 1000;
            ct.model.countingDown = (seconds > 0); // if the diff is negative, we unset the countingDown flag since we're counting up now
            if(!ct.model.countingDown) seconds *= -1; // we aren't counting down so we need to reverse the sign
            var days    = Math.floor(seconds / (3600*24));
            seconds     -= days*3600*24;
            var hours   = Math.floor(seconds / 3600);
            seconds     -= hours*3600;
            var minutes = Math.floor(seconds / 60);
            seconds     -= minutes*60;

            ct.model.days = days;
            ct.model.hours = (hours < 10) ? '0' + hours : hours;
            ct.model.minutes = (minutes < 10) ? '0' + minutes : minutes;
            ct.model.seconds = (seconds < 10 ) ? '0' + _.toInteger(seconds) : _.toInteger(seconds);
        }

        function init() {
            if(isValidStartEndTime()){
                ct.model.ticker = $interval(function () {
                    tick();

                    if(!ct.model.timerInitialized){ ct.model.timerInitialized = true; }
                }, 1000);
            }
        }

        function destroy() {
            if(_.has(ct, 'model.ticker')){
                $interval.cancel(ct.model.ticker);
            }
        }

        $scope.$watch(function () {
            return ct.startEndTime;
        }, function (oldVal, newVal) {
            if(oldVal !== newVal) {
                init();
            }
        }, true);
    }
]);

_module.component('countdownTimer', {
    template: require('./index.html'),
    controllerAs: 'ct',
    controller: 'CountdownTimerCtrl',
    bindings: {
        startEndTime: '@'
    }
});
